export default __webpack_public_path__ + "assets/images/71eeb5e9d84923f11704ed7ec3739459.png";